/**
 * dd-manager.ts 4.2.6
 * Copyright (c) 2021 Alain Dumesny - see GridStack root license
 */

import { DDDraggable } from './dd-draggable';

export class DDManager {
  static dragElement: DDDraggable;
}
